<template>
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
    @click.self="$emit('close')"
  >
    <div class="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative mx-4 flex flex-col">
      <button
        class="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xl"
        @click="$emit('close')"
      >
        <svg
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      
      <StepOne
        v-if="currentStep === 'one'"
        @close="$emit('close')"
        @upload="handleUpload"
      />

      <StepTwo v-else-if="currentStep === 'two'" />

      <StepThree
        v-else-if="currentStep === 'three'"
        :upload-result="uploadResult"
        :correct-rows="correctRows"
        @close="$emit('close')"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import StepOne from "./StepOne.vue";
import StepTwo from "./StepTwo.vue";
import StepThree from "./StepThree.vue";

const store = useStore();
let session = computed(() => store.getters.getUserSession);

defineEmits(["close"]);

const currentStep = ref("one");
const correctRows = ref(0);
const uploadResult = ref({
  success: false,
  message: '',
  total: 0,
  saved: 0,
  notSaved: 0,
  invalid: 0,
  valid: 0,
  savedRows: [],
  failedRows: [],
  invalidRows: [],
  error: null
});

const handleUpload = async (excelFile) => {
  currentStep.value = "two";

  try {
    const formData = new FormData();
    formData.append('file', excelFile);

    const response = await fetch(
      `${process.env.VUE_APP_API_BASE_URL}/broker/lead/${session.value.id}/upload-template`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
        body: formData,
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      correctRows.value = data.summary.valid;
      
      uploadResult.value = {
        success: true,
        total: data.summary.total,
        saved: data.summary.saved,
        notSaved: data.summary.not_saved,
        savedRows: data.saved_rows || [],
        failedRows: data.failed_rows || []
      };
      
    } else {
      uploadResult.value = {
        success: false,
        message: data.message || 'Error en la importación',
        invalidRows: data.invalid_rows || [],
        summary: data.summary || { total: 0, valid: 0, invalid: 0 }
      };
    }
  } catch (e) {
    uploadResult.value = {
      success: false,
      message: 'Error al procesar el archivo',
    };
  }

  currentStep.value = "three";
};
</script>